import { useParams } from 'react-router-dom'
import { FormattedFormProps } from '../components/Checking/CoverDraftPhaseThree/UpdateCoverDraftForm'
import { useAcsFetch } from '../hooks/use-acs-fetch'

export const useUpdateCoverDraftApi = (): {
  updateCoverDraft: (
    values: FormattedFormProps,
  ) => Promise<Record<string, never>>
} => {
  const { id } = useParams<{ id: string }>()

  const acsFetch = useAcsFetch({ withCif: true, withGuid: true })

  const updateCoverDraft = async (
    values: FormattedFormProps,
  ): Promise<Record<string, never>> => {
    const body = {
      alwaysMaxAmountIndicator: false,
      allowanceCustomerIndicator: values.coverDraftIndicator,
      accountId: id,
      allowanceCustomerReqAmount: values.coverDraftAmount,
    }
    await acsFetch(`/v1/bank-accounts/accounts`, {
      method: 'POST',
      headers: {
        'patron-id': 'olbWeb',
      },
      body: JSON.stringify(body),
    })
    return {}
  }

  return {
    updateCoverDraft,
  }
}
